import { RulesLogic } from 'json-logic-js';

export enum AssignmentRuleType {
    all = 'All',
    selected = 'Selected',
    single = 'Single',
}

export interface AssignmentRuleAll {
    type: AssignmentRuleType.all;
}

export interface AssignmentRuleSelected {
    type: AssignmentRuleType.selected;
    // Null represents when Subset of Entities selected but no rules has been added
    expression: RulesLogic | null;
}

export interface AssignmentRuleSingle {
    type: AssignmentRuleType.single;
    entityId: string;
}

export type AssignmentRule =
    | AssignmentRuleAll
    | AssignmentRuleSelected
    | AssignmentRuleSingle;
